import { c as _c } from "react/compiler-runtime";
import { Keyword } from "@/shared/types/type/search";
import { Icon, Typography } from "@/shared/ui/atoms";
import { useTranslations } from "next-intl";
interface HospitalKeywordsProps {
  positiveKeywords: Keyword[];
  negativeKeywords: Keyword[];
}
const HospitalKeywords = t0 => {
  const $ = _c(15);
  const {
    positiveKeywords,
    negativeKeywords
  } = t0;
  const t = useTranslations();
  if (positiveKeywords.length === 0 && negativeKeywords.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon src="/icons/data-trending.svg" alt="tag" width={16} height={16} className="my-[3px]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("commonHospitalKeywords.hotKeywords");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Typography size={12} lineHeight={22} className="flex font-medium text-[#46474C] gap-1">{t1}{t2}</Typography>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== positiveKeywords) {
    t4 = positiveKeywords.map(_temp);
    $[5] = positiveKeywords;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== negativeKeywords) {
    t5 = negativeKeywords.map(_temp2);
    $[7] = negativeKeywords;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex gap-[6px] flex-wrap">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <div className="flex flex-col gap-1">{t3}{t6}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default HospitalKeywords;
function _temp(keyword) {
  return <Typography key={keyword.keyword} size={14} className="w-fit py-[6px] px-2 font-medium text-[#212225] rounded-lg bg-[#F6F2FF] whitespace-nowrap">{keyword.keyword} {keyword.count}</Typography>;
}
function _temp2(keyword_0) {
  return <Typography key={keyword_0.keyword} size={14} className="w-fit py-[6px] px-2 font-medium text-[#212225] rounded-lg bg-[#F4F4F5] whitespace-nowrap">{keyword_0.keyword} {keyword_0.count}</Typography>;
}